import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { blogPosts } from '../data/blog';
import { JsonLd, useSEO } from '../utils/seo';
export function Blog() {
  useSEO({
    title: 'Gravel, Driveway & Landscaping Guides | 206Gravel',
    description: 'Practical guides for choosing gravel, building driveways, improving drainage, and planning bulk material delivery in the Puget Sound area.',
    path: '/blog'
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="pt-24 pb-20 bg-[#f] dark:bg-[#252423] min-h-screen" data-id="element-1976" data-mp="3uflqn2urco3l">
      <JsonLd data={{
      '@context': 'https://schema.org',
      '@type': 'Blog',
      name: '206Gravel Guides & Tips',
      url: 'https://206gravel.com/blog',
      blogPost: blogPosts.map(post => ({
        '@type': 'BlogPosting',
        headline: post.title,
        datePublished: post.date,
        image: post.image,
        url: `https://206gravel.com/blog/${post.slug}`,
        description: post.excerpt
      }))
    }} data-id="element-1977" data-mp="cxsp7kmajoeb" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1978" data-mp="2253xs43nx5ol">
        <header className="mb-12 text-center" data-id="element-1979" data-mp="273f4w72kp234">
          <h1 className="font-heading text-4xl md:text-5xl font-extrabold text-brand-charcoal dark:text-white tracking-tight uppercase" data-id="element-1980" data-mp="27241w9gybyd2">
            Blog: Guides & Tips
          </h1>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1981" data-mp="2fylfrkgpaaci">
          {blogPosts.map((post, idx) => <motion.article key={post.slug} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white dark:bg-[#333333] rounded-2xl overflow-hidden shadow-sm border border-stone-200 dark:border-white/10 hover:shadow-md transition-shadow flex flex-col" data-id="element-1982" data-mp="1o5l0k6ce3er2" data-mpi={idx}>
              <Link to={`/blog/${post.slug}`} className="block aspect-video overflow-hidden" data-id="element-1983" data-mp="33ophtne8q21e">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-1984" data-mp="38niw3i1cpx2m" />
              </Link>
              <div className="p-6 flex flex-col flex-grow" data-id="element-1985" data-mp="14gtiy0w6t185">
                <p className="text-sm text-brand-muted dark:text-stone-400 italic mb-2" data-id="element-1986" data-mp="1ih48n0lrg9rq">
                  {post.date}
                </p>
                <Link to={`/blog/${post.slug}`} data-id="element-1987" data-mp="1djkvk40su31d">
                  <h2 className="font-heading text-xl font-extrabold text-brand-charcoal dark:text-white uppercase mb-3 hover:text-brand-orange transition-colors" data-id="element-1988" data-mp="psoyardkqfmq">
                    {post.title}
                  </h2>
                </Link>
                <p className="text-brand-muted dark:text-stone-300 text-sm leading-relaxed flex-grow" data-id="element-1989" data-mp="zja4azvkumfo">
                  {post.excerpt}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </main>;
}